var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.key,staticClass:"app-container"},[_c('tab1',{on:{"update":_vm.forceUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }